module.exports = __webpack_public_path__ + "static/media/Citrus.2acb63bf.jpg";